<template>
  <div class="blank-container">
    <router-view />
  </div>
</template>

<script>
  export default {
    title: 'Blank Layout',
  }
</script>

<style scoped lang="scss">
  div.blank-container {
    height: 100%;
    margin: 0 auto;
  }
</style>
